import { ControlcenterMelcoModelsHoop, VerticalForm } from "melco-shared-logic"
import { SavePublishHeader } from "../header/SavePublishHeader"
import { Spin, Tabs, TabsProps } from "melco-ui"
import { useFormikContext } from "formik"
import { useRevertHoops } from "../../hooks/hoops/useRevertHoop"
import { BasicHoopTab } from "./tabs/BasicHoopTab"
import { HoopProductsTab } from "./tabs/HoopProductsTab"
import { HoopMachinesTab } from "./tabs/HoopMachinesTab"
import { HoopCategoriesTab } from "./tabs/HoopCategoriesTab"
import { HoopAssetTab } from "./tabs/HoopAssetTab"
import { DisplayCustomHoopFormErrors } from "./DisplayCustomHoopFormErrors"
import { useTranslation } from "react-i18next"
import { useDownloadHoop } from "../../hooks/hoops/useDownloadHoop"
import { saveAs } from "file-saver"
import { FILE_FORMAT_HOOP } from "../../helper/commonHelper"
import { useState } from "react"
import styled from "styled-components"

type DisplayUpdateHoopFormProps = {
    hoop: ControlcenterMelcoModelsHoop;
    refetch: any;
}

const TabsWrapper = styled.div`
  position: relative;
`;

/* Overlay (controlled by prop) */
const TabsOverlay = styled.div<{ $isUploading: boolean }>`
  position: absolute;
  inset: 0;
  z-index: 10;
  cursor: not-allowed;
  display: ${({ $isUploading }) => ($isUploading ? "block" : "none")};
`;


const StyledSpin = styled(Spin)`
  width: 100%;
`;

export const DisplayUpdateHoopForm: React.FC<DisplayUpdateHoopFormProps> = ({ hoop, refetch }) => {

    const { status } = useFormikContext();
    //useFormik({ initialValues: hoop, onSubmit: () => { } });
    console.log(status)
    const { created_date,
        publish_state,
        published_date,
        updated_date,
        warning_list,
        cloud_id,

    } = hoop;


    const [isCurrentlyDownloading, setIsCurrentlyDownloading] = useState(false)
    const [revertHoops, isLoading] = useRevertHoops(cloud_id!, refetch);
    const [downloadHoop] = useDownloadHoop(cloud_id ?? "")
    const hoopFilename = `hoop-${new Date().toISOString()}` + FILE_FORMAT_HOOP
    const [isUploading, setIsUploading] = useState(false);

    const downloadHoopAction = async () => {
        setIsCurrentlyDownloading(true)
        try {
            const blob = await downloadHoop();
            console.log(blob);
            if (blob) {
                saveAs(blob, hoopFilename);
            }
            else {
                console.log("It is not blob");
            }
            setIsCurrentlyDownloading(false)
        }
        catch (exp) {
            console.log("exception : ", exp)
            console.log(JSON.stringify(exp))
            setIsCurrentlyDownloading(false)
        }
    }

    const { t } = useTranslation();

    const items: TabsProps["items"] = [
        {
            key: "basic",
            label: t("managehoops.tabs.basic.title"),
            children: hoop && <BasicHoopTab />

        }
        ,
        {
            key: "products",
            label: t("managehoops.tabs.products.title"),
            children: <HoopProductsTab />
        },
        {
            key: "categories",
            label: t("managehoops.tabs.categories.title"),
            children: <HoopCategoriesTab />,
            //active: true

        },
        {
            key: "machines",
            label: t("managehoops.tabs.machines.title"),
            children: <HoopMachinesTab hoop={hoop} />
        },
        {
            key: "asset",
            label: t("managehoops.tabs.asset.title"),
            children: <HoopAssetTab setIsUploading={setIsUploading} hoop={hoop} />
        }

    ]
    return <>

        <VerticalForm>

            <SavePublishHeader
                createdDate={created_date!}
                isCurrentlyReverting={isLoading}
                publishedState={publish_state!}
                revertAction={revertHoops}
                publishedDate={published_date}
                updatedDate={updated_date}
                title="Details"
                warnings={warning_list ?? undefined}
                download={true}
                downloadAction={downloadHoopAction}
                isCurrentlyDownloading={isCurrentlyDownloading}
            />
            {/* <DisplayFieldErrors name="category_list" aggregateErrors /> */}
            <DisplayCustomHoopFormErrors />
            <TabsWrapper>
                <StyledSpin spinning={isUploading}>

                    <Tabs items={items} />
                </StyledSpin>

                {isUploading && <TabsOverlay $isUploading={isUploading} />}
            </TabsWrapper>

        </VerticalForm>

    </>
}